// extracted by mini-css-extract-plugin
export default {"scroller":"Landing_scroller__LiDF2","usp":"Landing_usp__4jjFr"};